import {getQueryParams} from '@wix/music-shared/dist/src/utils/queryParams/queryParams';

export const getPlayerVersion = () => {
  return getQueryParams().playerVersion || 'v3';
};
